import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error('Passwords do not match');
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.phone);
      toast.success('Account created! Welcome to YAMASS');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const f = (key) => ({ value: form[key], onChange: e => setForm(p => ({ ...p, [key]: e.target.value })) });

  const contactFields = [
    { label: 'Full Name', key: 'name', type: 'text', required: true },
    {
      label: 'Email',
      key: 'email',
      type: 'email',
      required: true,
      placeholder: 'name@example.com',
    },
    {
      label: 'Phone number',
      key: 'phone',
      type: 'tel',
      required: true,
      placeholder: '01XXXXXXXXX',
    },
    { label: 'Password', key: 'password', type: 'password', required: true },
    { label: 'Confirm Password', key: 'confirm', type: 'password', required: true },
  ];

  return (
    <div className="min-h-screen bg-yamass-cream flex items-center justify-center px-4 py-12">
      <div className="bg-white rounded-3xl shadow-sm p-10 w-full max-w-md">
        <h1 className="font-display text-3xl font-bold text-yamass-black mb-2">Create account</h1>
        <p className="text-gray-400 text-sm mb-8">Join YAMASS and shop the whole family</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          {contactFields.map(field => (
            <div key={field.key}>
              <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">{field.label}</label>
              {field.helper && (
                <p className="text-xs text-gray-400 mb-2">{field.helper}</p>
              )}
              <input
                type={field.type}
                required={field.required}
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-yamass-accent"
                placeholder={field.placeholder}
                {...f(field.key)}
              />
            </div>
          ))}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-yamass-black text-white py-4 rounded-full text-sm font-semibold hover:bg-yamass-accent transition-colors disabled:opacity-50 mt-2"
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
        <p className="text-center text-sm text-gray-400 mt-6">
          Already have an account?{' '}
          <Link to="/login" className="text-yamass-accent font-medium hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
